import React from "react";
import { connect } from "react-redux";
import {BackwardIcon, ExclamationCircleIcon, ExclamationTriangleIcon, XMarkIcon,} from "@heroicons/react/20/solid";
import { Actions as PAYMENTACTIONS } from "../../store/actions/paymentActions";

const StripeDeleteModal = ({ modalStatus, closeModal, selectedMethod, deleteStripe, stripId }) => {
  if (!modalStatus) return null;
  return (
    <div className="modal" tabIndex="-1" role="dialog" aria-hidden="true" 
    style={{ display: "block", background: "rgba(0,0,0,0.4)", overflow: "auto",}}>
      <div className="modal-dialog" style={{ width: "40%" }}>
        <div className="modal-content">
          <div
            className="block block-themed block-transparent remove-margin-b"
            style={{ padding: 0 }}>
            <div
              className="block-header bg-primary-dark"
              style={{ padding: 20, position: "sticky", top: 0, zIndex: 50 }}>
              <ul className="block-options">
                <li>
                  <button type="button" onClick={closeModal}>
                    <XMarkIcon className="h-6 w-6 mr-3 text-white" />
                  </button>
                </li>
              </ul>
              <h3 className="block-title">
                Delete {selectedMethod?.brand} ending in {selectedMethod?.last4}
                ?
              </h3>
            </div>
            <div className="block-content" style={{ paddingBottom: 20 }}>
              <div style={{ width: "100%" }}>
                <ExclamationCircleIcon
                  style={{
                    width: "20%",
                    height: "20%",
                    color: "red",
                    padding: 10,
                  }}
                />
                <div
                  className="pull-right"
                  style={{ width: "80%", paddingLeft: 10 }}
                >
                  <p>
                    Are you sure you want to delete {selectedMethod?.brand}{" "}
                    ending in {selectedMethod?.last4}?
                    <br />
                    You will no longer be able to use this card for transactions
                    unless you reinsert the details.
                  </p>
                </div>
              </div>
              <div className="clearfix"></div>
              <button className="btn btn-success" onClick={closeModal}>
                <BackwardIcon
                  style={{ height: "1.5em", float: "left", marginRight: 5 }}
                />
                No
              </button>
              <button className="btn btn-danger pull-right" onClick={() => {
                closeModal(); 
                deleteStripe(stripId)}}>
                <ExclamationTriangleIcon
                  style={{ height: "1.5em", float: "left", marginRight: 5 }}
                />
                Yes
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const paymentOptions = state.payment?.stripe?.paymentMethods?.map((item) => ({
    value: item.id,
    label: `•••• •••• •••• ${item.card.last4} - ${item.card.exp_month}/${item.card.exp_year}`,
    brand: item.card.brand,
    last4: item.card.last4,
    expiry: `${item.card.exp_month}/${item.card.exp_year}`,
    email: item.billing_details.email,
    phone: item.billing_details.phone,
  }));
  const selectedMethod = paymentOptions?.find(
    (item) => item.value == state.payment?.stripeDeleteModalId
  );

  return {
    modalStatus: state.payment?.stripeDeleteModal,
    stripId: state.payment?.stripeDeleteModalId,
    selectedMethod,
  };
};

const mapDispatchToProps = (dispatch) => ({
  closeModal: () => dispatch(PAYMENTACTIONS.showStripeDeleteModal(false)),
  deleteStripe: (id) => dispatch(PAYMENTACTIONS.deleteStripe(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(StripeDeleteModal);
